import { app } from "@thomasphan/vue-components/src/functions/initializeApp";
import { getAuth, connectAuthEmulator  } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';

const auth = getAuth(app);
const db = getDatabase(app);

if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, 'http://192.168.1.13:9099');
  connectDatabaseEmulator(db, '192.168.1.13', 9000);
}
